// extracted by mini-css-extract-plugin
export default {"wrapper":"Fb","container":"Gb","slide":"Hb","list":"Ib","scroll":"Jb","logo":"Kb","blinking":"Lb","gradientShift":"Mb","float":"Nb","move":"Ob"};